import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "lxc",
  "use": "lxc-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"lxc\"><path d=\"M8.69 6.35 4.96 4.26l-3.58 2 3.74 2.09zM5.26 9.59l3.59-2.01V6.6L5.26 8.61zm7.48 0v-.98l-3.59-2v.98zm-7.78.17V8.61L1.22 6.52v1.19l3.7 2.07zm11.66-3.5L9 2 5.26 4.09l7.62 4.26zm-3.58 5.21h-.07l-3.84 2.15V16l7.65-4.28V9.34l-3.74 2.09zm-.3-.22v-.94l-3.61 2.02v.94zm.3-2.64v2.47l3.74-2.09V6.52zM1.22 11.72 8.87 16v-2.39L1.22 9.34zm11.52-1.79L9 7.84 5.26 9.93v.04L9 12.06l3.74-2.09zM1.22 8.99l7.65 4.28v-.94L1.22 8.06z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol